// @flow
import JitsiMeetJS from 'lib-jitsi-meet';
export default JitsiMeetJS;
